module.exports = __webpack_public_path__ + "img/logo-lightmode.885da025.svg";